import { ArrowLeft } from "lucide-react";

export const StepHeader = ({ onBack, backLabel = "Wróć", num, title, sub }) => (
  <div className="mb-8 rise">
    <button data-testid="step-back-button" onClick={onBack} className="flex items-center gap-2 text-xs text-white/60 hover:text-primary transition-colors mb-6">
      <ArrowLeft size={14} /> {backLabel}
    </button>
    <h1 className="font-display text-3xl sm:text-4xl font-bold">
      {num && <span className="text-primary mr-2">{num}.</span>}{title}
    </h1>
    {sub && <p className="text-sm text-muted-foreground mt-2">{sub}</p>}
  </div>
);

export const NextButton = ({ onClick, disabled, label = "Dalej", testid = "step-next-button", className = "" }) => (
  <button data-testid={testid} disabled={disabled} onClick={onClick} className={`btn-y px-8 py-3.5 sm:py-3 text-sm inline-flex items-center justify-center gap-2 w-full sm:w-auto ${className}`}>
    {label} <span aria-hidden>→</span>
  </button>
);
